import { useState } from 'react';
import { Button } from '@/components/ui/button';
import {
    Tooltip,
    TooltipContent,
    TooltipProvider,
    TooltipTrigger,
} from '@/components/ui/tooltip';
import { useToast } from '@/hooks/use-toast';
import { useNavigate } from 'react-router-dom';
// ❌ PHASE 1A: Retiré import useDashboardWithPolling
import { useReports } from '@/hooks/useReports';
import { useDraftActions } from '@/hooks/useDraftActions';
import { supabase } from '@/integrations/supabase/client';
import { CampaignDetailsDialog } from "./CampaignDetailsDialog";
import { CampaignCancelDialogWithReason } from "./CampaignCancelDialogWithReason";
import { CampaignDeleteDialog } from "./CampaignDeleteDialog";
import { DraftDeleteDialog } from "./DraftDeleteDialog";
import { ReferentSelectionModal } from "./ReferentSelectionModal";

// Composants d'icônes personnalisées
const EyeIcon = () => (
  <div data-svg-wrapper className="relative">
    <svg width="20" height="20" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M10.3866 8.95454C10.3866 10.2745 9.31995 11.3412 7.99995 11.3412C6.67995 11.3412 5.61328 10.2745 5.61328 8.95454C5.61328 7.63454 6.67995 6.56787 7.99995 6.56787C9.31995 6.56787 10.3866 7.63454 10.3866 8.95454Z" stroke="#40E0D0" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M7.9999 14.4679C10.3532 14.4679 12.5466 13.0812 14.0732 10.6812C14.6732 9.74124 14.6732 8.16124 14.0732 7.22124C12.5466 4.82124 10.3532 3.43457 7.9999 3.43457C5.64656 3.43457 3.45323 4.82124 1.92656 7.22124C1.32656 8.16124 1.32656 9.74124 1.92656 10.6812C3.45323 13.0812 5.64656 14.4679 7.9999 14.4679Z" stroke="#40E0D0" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  </div>
);

const DownloadIcon = () => (
  <div data-svg-wrapper className="relative">
    <svg width="20" height="20" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_655_7999)">
        <path d="M12.6667 7.46973C12.6667 6.92439 12.6667 6.42306 12.5653 6.17839C12.464 5.93373 12.2713 5.74039 11.8853 5.35506L8.728 2.19773C8.39533 1.86506 8.22933 1.69906 8.02267 1.60039C7.97989 1.57985 7.93605 1.5616 7.89133 1.54573C7.676 1.46973 7.44067 1.46973 6.97067 1.46973C4.80733 1.46973 3.72533 1.46973 2.99267 2.06039C2.84472 2.17969 2.70996 2.31445 2.59067 2.46239C2 3.19639 2 4.27706 2 6.44039V9.46973C2 11.9837 2 13.2411 2.78133 14.0217C3.56267 14.8024 4.81933 14.8031 7.33333 14.8031H12.6667M8 1.80306V2.13639C8 4.02173 8 4.96506 8.586 5.55039C9.17133 6.13639 10.1147 6.13639 12 6.13639H12.3333" stroke="#FF7F50" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M14.0003 9.46973H12.667C12.4902 9.46973 12.3206 9.53996 12.1956 9.66499C12.0706 9.79001 12.0003 9.95958 12.0003 10.1364V11.1364M12.0003 11.1364V12.8031M12.0003 11.1364H13.667M4.66699 12.8031V11.4697M4.66699 11.4697V9.46973H5.66699C5.93221 9.46973 6.18656 9.57508 6.3741 9.76262C6.56164 9.95016 6.66699 10.2045 6.66699 10.4697C6.66699 10.7349 6.56164 10.9893 6.3741 11.1768C6.18656 11.3644 5.93221 11.4697 5.66699 11.4697H4.66699ZM8.33366 9.46973H9.19099C9.82233 9.46973 10.3337 9.96706 10.3337 10.5811V11.6917C10.3337 12.3051 9.82166 12.8031 9.19099 12.8031H8.33366V9.46973Z" stroke="#FF7F50" strokeLinecap="round" strokeLinejoin="round"/>
      </g>
      <defs>
        <clipPath id="clip0_655_7999">
          <rect width="16" height="16" fill="white" transform="translate(0 0.13623)"/>
        </clipPath>
      </defs>
    </svg>
  </div>
);

const TrashIcon = () => (
  <div data-svg-wrapper className="relative">
    <svg width="20" height="20" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M13.3337 4.8029C11.3603 4.3629 9.37514 4.13623 7.39588 4.13623C6.22255 4.13623 5.04921 4.26956 3.87588 4.53623L2.66699 4.8029" stroke="#FF515D" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M6 4.13623L6.12571 3.25408C6.21714 2.61435 6.28571 2.13623 7.25143 2.13623H8.74857C9.71429 2.13623 9.78857 2.64128 9.87429 3.26081L10 4.13623" stroke="#FF515D" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M12 6.80273L11.6204 12.5451C11.5562 13.4404 11.5036 14.1361 9.87445 14.1361H6.12555C4.49635 14.1361 4.4438 13.4404 4.37956 12.5451L4 6.80273" stroke="#FF515D" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M7.33301 10.8027H8.66634" stroke="#FF515D" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M6.66699 8.13623H9.33366" stroke="#FF515D" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  </div>
);

const SendIcon = () => (
  <div data-svg-wrapper className="relative">
    <svg width="20" height="20" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M14.3337 1.98438L9.90033 14.651L7.36699 8.95104L1.66699 6.41771L14.3337 1.98438Z" stroke="#FF7F50" strokeLinejoin="round"/>
      <path d="M14.3339 1.98438L7.36719 8.95104" stroke="#FF7F50" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  </div>
);

const CancelIcon = () => (
  <div className="size-5 relative">
    <div data-svg-wrapper className="left-0 top-0 absolute">
      <svg width="20" height="20" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M7.99967 15.6214C11.6797 15.6214 14.6663 12.6348 14.6663 8.95475C14.6663 5.27475 11.6797 2.28809 7.99967 2.28809C4.31967 2.28809 1.33301 5.27475 1.33301 8.95475C1.33301 12.6348 4.31967 15.6214 7.99967 15.6214Z" stroke="#FFC506" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M12.5999 4.28809L3.2666 13.6214" stroke="#FFC506" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
    </div>
  </div>
);

const EditIcon = () => (
  <div data-svg-wrapper className="relative">
    <svg width="20" height="20" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M8.83463 2.59996L3.94546 7.66913C3.76463 7.86163 3.58963 8.2408 3.55463 8.5033L3.3388 10.3933C3.26296 11.0758 3.75296 11.5425 4.42963 11.4258L6.30796 11.105C6.57046 11.0583 6.93796 10.8658 7.11879 10.6675L11.908 5.5983C12.7363 4.7233 13.1096 3.7258 11.8205 2.50663C10.5371 1.29913 9.56296 1.72496 8.83463 2.59996Z" stroke="#40E0D0" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M7.93555 3.4458C8.18638 5.0558 9.49305 6.28663 11.1147 6.44997" stroke="#40E0D0" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M2.75 13.3333H13.25" stroke="#40E0D0" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  </div>
);

interface CampaignActionsIconsProps {
    campaignId: string;
    campaignStatus: string;
    completedReferents?: number;
    totalReferents?: number;
    isDraft?: boolean;
    candidateName?: string;
    refetchCampaigns: () => void; // ✅ PHASE 1A: Prop au lieu de hook
}

export const CampaignActionsIcons = ({
    campaignId,
    campaignStatus,
    isDraft = false,
    candidateName,
    refetchCampaigns // ✅ PHASE 1A: Reçu en prop
}: CampaignActionsIconsProps) => {
    const [showCancelDialog, setShowCancelDialog] = useState(false);
    const [showDeleteDialog, setShowDeleteDialog] = useState(false);
    const [showDraftDeleteDialog, setShowDraftDeleteDialog] = useState(false);
    const [showDetailsDialog, setShowDetailsDialog] = useState(false);
    const [showReminderDialog, setShowReminderDialog] = useState(false);
    const [campaignDetails, setCampaignDetails] = useState<any>(null);
    const [isDeleting, setIsDeleting] = useState(false);
    const { toast } = useToast();
    // ❌ PHASE 1A: Retiré useDashboardWithPolling
    const { reports } = useReports();
    const { editDraft, deleteDraft, deletingId } = useDraftActions();
    const navigate = useNavigate();

    // Déterminer les statuts
    const isCompleted = campaignStatus === 'Terminé';
    const isRefused = campaignStatus === 'Refusé';
    const isPendingCandidate = campaignStatus === 'En attente candidat';
    const isPendingReferents = campaignStatus === 'En attente référent(s)';

    // Trouver le rapport pour cette campagne
    const campaignReport = reports?.find(r => r.campaign_id === campaignId);

    const fetchCampaignDetails = async (callback: (data: any) => void, errorMsg: string) => {
        try {
            // Récupérer la campagne avec les référents
            const { data: campaignData, error: campaignError } = await supabase
                .from('campaigns')
                .select(`
          *,
          referents(*)
        `)
                .eq('id', campaignId)
                .single();

            if (campaignError) throw campaignError;

            // Récupérer les réponses du candidat séparément
            const { data: candidateResponses, error: responseError } = await supabase
                .from('candidate_responses')
                .select('*')
                .eq('campaign_id', campaignId);

            if (responseError) throw responseError;

            // Combiner les données
            const data = {
                ...campaignData,
                candidate_responses: candidateResponses || []
            };

            callback(data);
        } catch (_error) {
            toast({
                title: "Erreur",
                description: errorMsg,
                variant: "destructive",
            });
        }
    };

    const handleViewDetails = () => {
        fetchCampaignDetails((data) => {
            setCampaignDetails(data);
            setShowDetailsDialog(true);
        }, "Impossible de charger les détails de la campagne.");
    };

    const handleDownloadReport = () => {
        if (!campaignReport) {
            toast({
                title: "Rapport non disponible",
                description: "Le rapport n'a pas encore été généré pour cette campagne.",
                variant: "destructive",
            });
            return;
        }

        // Rediriger vers la page Reports avec le rapport sélectionné
        navigate('/reports', { 
            state: { 
                selectedReportId: campaignReport.id,
                fromDashboard: true 
            } 
        });
        
        toast({
            title: "Ouverture du rapport",
            description: "Le rapport s'ouvre. Utilisez le bouton PDF dans le rapport pour télécharger.",
        });
    };

    const handleSendReminder = () => {
        fetchCampaignDetails((data) => {
            setCampaignDetails(data);
            setShowReminderDialog(true);
        }, "Impossible de charger les données de la campagne.");
    };

    const handleCancelCampaign = async (reasonType: string, reasonDetails?: string) => {
        try {
            const { data: { user } } = await supabase.auth.getUser();
            if (!user) throw new Error('User not authenticated');

            const { error } = await supabase.functions.invoke('cancel-campaign', {
                body: {
                    campaign_id: campaignId,
                    recruiter_id: user.id,
                    reason_type: reasonType,
                    reason_details: reasonDetails
                }
            });

            if (error) throw error;

            toast({
                title: "Campagne annulée",
                description: "La campagne a été annulée et les notifications ont été envoyées.",
            });
            setShowCancelDialog(false);
            refetchCampaigns();
        } catch (error) {
            console.error('Erreur annulation campagne:', error);
            toast({
                title: "Erreur",
                description: "Impossible d'annuler la campagne.",
                variant: "destructive",
            });
        }
    };

    const handleDeleteCampaign = async () => {
        setIsDeleting(true);
        try {
            const { error } = await supabase.functions.invoke('delete-campaign-cascade', {
                body: { campaignId }
            });

            if (error) throw error;

            toast({
                title: "Campagne supprimée",
                description: "La campagne et toutes ses données ont été supprimées définitivement.",
            });
            setShowDeleteDialog(false);
            refetchCampaigns();
        } catch (error) {
            console.error('Error deleting campaign:', error);
            toast({
                title: "Erreur",
                description: "Impossible de supprimer la campagne. Veuillez réessayer.",
                variant: "destructive",
            });
        } finally {
            setIsDeleting(false);
        }
    };

    const handleDraftDelete = () => {
        deleteDraft(campaignId, refetchCampaigns);
        setShowDraftDeleteDialog(false);
    };

    // Fonction pour rendre les icônes selon le statut
    const renderActionIcons = () => {
        const buttonClass = "h-8 w-8 p-0 hover:bg-gray-100 transition-colors";

        // Actions spécifiques pour les brouillons
        if (isDraft) {
            return (
                <TooltipProvider>
                    <div className="flex items-center gap-1">
                        <Tooltip>
                            <TooltipTrigger asChild>
                                <Button
                                    variant="ghost"
                                    size="sm"
                                    className={buttonClass}
                                    onClick={() => editDraft(campaignId)}
                                >
                                    <EditIcon />
                                </Button>
                            </TooltipTrigger>
                            <TooltipContent>
                                <p>Continuer l'édition</p>
                            </TooltipContent>
                        </Tooltip>

                        <Tooltip>
                            <TooltipTrigger asChild>
                                <Button
                                    variant="ghost"
                                    size="sm"
                                    className={buttonClass}
                                    onClick={() => setShowDraftDeleteDialog(true)}
                                    disabled={deletingId === campaignId}
                                >
                                    <TrashIcon />
                                </Button>
                            </TooltipTrigger>
                            <TooltipContent>
                                <p>Supprimer le brouillon</p>
                            </TooltipContent>
                        </Tooltip>
                    </div>
                </TooltipProvider>
            );
        }

        if (isCompleted) {
            // Terminé : Voir le détail, télécharger le rapport, supprimer
            return (
                <TooltipProvider>
                    <div className="flex items-center gap-1">
                        <Tooltip>
                            <TooltipTrigger asChild>
                                <Button
                                    variant="ghost"
                                    size="sm"
                                    className={buttonClass}
                                    onClick={handleViewDetails}
                                >
                                    <EyeIcon />
                                </Button>
                            </TooltipTrigger>
                            <TooltipContent>
                                <p>Voir les détails</p>
                            </TooltipContent>
                        </Tooltip>

                        <Tooltip>
                            <TooltipTrigger asChild>
                                <Button
                                    variant="ghost"
                                    size="sm"
                                    className={buttonClass}
                                    onClick={handleDownloadReport}
                                    disabled={!campaignReport}
                                >
                                    <DownloadIcon />
                                </Button>
                            </TooltipTrigger>
                            <TooltipContent>
                                <p>{campaignReport ? 'Télécharger le rapport' : 'Rapport non disponible'}</p>
                            </TooltipContent>
                        </Tooltip>

                        <Tooltip>
                            <TooltipTrigger asChild>
                                <Button
                                    variant="ghost"
                                    size="sm"
                                    className={buttonClass}
                                    onClick={() => setShowDeleteDialog(true)}
                                >
                                    <TrashIcon />
                                </Button>
                            </TooltipTrigger>
                            <TooltipContent>
                                <p>Supprimer la campagne</p>
                            </TooltipContent>
                        </Tooltip>
                    </div>
                </TooltipProvider>
            );
        }

        if (isPendingCandidate || isPendingReferents) {
            // En attente : Voir le détail, relancer, annuler, supprimer
            return (
                <TooltipProvider>
                    <div className="flex items-center gap-1">
                        <Tooltip>
                            <TooltipTrigger asChild>
                                <Button
                                    variant="ghost"
                                    size="sm"
                                    className={buttonClass}
                                    onClick={handleViewDetails}
                                >
                                    <EyeIcon />
                                </Button>
                            </TooltipTrigger>
                            <TooltipContent>
                                <p>Voir les détails</p>
                            </TooltipContent>
                        </Tooltip>

                        <Tooltip>
                            <TooltipTrigger asChild>
                                <Button
                                    variant="ghost"
                                    size="sm"
                                    className={buttonClass}
                                    onClick={handleSendReminder}
                                >
                                    <SendIcon />
                                </Button>
                            </TooltipTrigger>
                            <TooltipContent>
                                <p>Relancer</p>
                            </TooltipContent>
                        </Tooltip>

                        <Tooltip>
                            <TooltipTrigger asChild>
                                <Button
                                    variant="ghost"
                                    size="sm"
                                    className={buttonClass}
                                    onClick={() => setShowCancelDialog(true)}
                                >
                                    <CancelIcon />
                                </Button>
                            </TooltipTrigger>
                            <TooltipContent>
                                <p>Annuler la campagne</p>
                            </TooltipContent>
                        </Tooltip>

                        <Tooltip>
                            <TooltipTrigger asChild>
                                <Button
                                    variant="ghost"
                                    size="sm"
                                    className={buttonClass}
                                    onClick={() => setShowDeleteDialog(true)}
                                >
                                    <TrashIcon />
                                </Button>
                            </TooltipTrigger>
                            <TooltipContent>
                                <p>Supprimer la campagne</p>
                            </TooltipContent>
                        </Tooltip>
                    </div>
                </TooltipProvider>
            );
        }

        if (isRefused) {
            // Refusé : Voir le détail seulement
            return (
                <TooltipProvider>
                    <div className="flex items-center gap-1">
                        <Tooltip>
                            <TooltipTrigger asChild>
                                <Button
                                    variant="ghost"
                                    size="sm"
                                    className={buttonClass}
                                    onClick={handleViewDetails}
                                >
                                    <EyeIcon />
                                </Button>
                            </TooltipTrigger>
                            <TooltipContent>
                                <p>Voir les détails</p>
                            </TooltipContent>
                        </Tooltip>
                    </div>
                </TooltipProvider>
            );
        }

        // Statut par défaut - au moins voir les détails
        return (
            <TooltipProvider>
                <div className="flex items-center gap-1">
                    <Tooltip>
                        <TooltipTrigger asChild>
                            <Button
                                variant="ghost"
                                size="sm"
                                className={buttonClass}
                                onClick={handleViewDetails}
                            >
                                <EyeIcon />
                            </Button>
                        </TooltipTrigger>
                        <TooltipContent>
                            <p>Voir les détails</p>
                        </TooltipContent>
                    </Tooltip>
                </div>
            </TooltipProvider>
        );
    };

    return (
        <>
            {renderActionIcons()}

            {/* DIALOGS */}
            <CampaignDetailsDialog
                open={showDetailsDialog}
                onOpenChange={setShowDetailsDialog}
                campaign={campaignDetails}
                onRefresh={refetchCampaigns}
            />

            <CampaignCancelDialogWithReason
                open={showCancelDialog}
                onOpenChange={setShowCancelDialog}
                onConfirm={handleCancelCampaign}
                campaignName={campaignDetails?.candidate_name}
            />

            <CampaignDeleteDialog
                open={showDeleteDialog}
                onOpenChange={setShowDeleteDialog}
                onConfirm={handleDeleteCampaign}
                campaignName={campaignDetails?.candidate_name}
                isDeleting={isDeleting}
            />

            {/* Dialog pour les rappels intelligents */}
            <ReferentSelectionModal
                open={showReminderDialog}
                onOpenChange={setShowReminderDialog}
                campaign={campaignDetails}
                onSuccess={() => {
                    setShowReminderDialog(false);
                    refetchCampaigns();
                }}
            />

            {/* Dialog de suppression de brouillon */}
            <DraftDeleteDialog
                open={showDraftDeleteDialog}
                onOpenChange={setShowDraftDeleteDialog}
                onConfirm={handleDraftDelete}
                candidateName={candidateName}
                isDeleting={deletingId === campaignId}
            />
        </>
    );
};